import ApiBase from '../ApiBase';

class CheckIn extends ApiBase {
  /**
   * @method submit
   * @param {object} data
   * @return {Promise<*>}
   */
  submit = (data) => {
    return this.post('guests/check-in', data, null, [200, 201]);
  };

  /**
   * @method checkOut
   * @param {string} id
   * @return {Promise<*>}
   */
  checkOut = (id) => {
    return this.post(`guests/check-in/${id}/checkout`, {});
  };
}

export default new CheckIn();
